export default (state = {}, { type, payload }) => {
  switch (type) {
    case 'RIGHT_TOOLBAR_EXPAND':
      return {
        expanded: true,
        dialog: payload.dialog,
        data: payload.data ? payload.data : null
      }
    case 'RIGHT_TOOLBAR_COLLAPSE':
      return {
        expanded: false,
        dialog: null,
        data: null
      }
    case 'RIGHT_TOOLBAR_HIDE':
      return {
        hidden: true
      }
    case 'RIGHT_TOOLBAR_SHOW':
      return {
        hidden: false
      }
    case 'LOGOUT':
      return {}
    default:
      return state
  }
}